var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:{ 'is-en': _vm.$i18n.locale === 'en' },attrs:{"id":"app"}},[(_vm.isViewAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }